export const onClientEntry = () => {
    window.addEventListener('unhandledrejection', event => {
      if (
        event.reason &&
        event.reason.message &&
        event.reason.message.includes("We couldn't load")
      ) {
        window.location.reload(true);
      }
    });
  };
  